import React from 'react'
import CHFImage from 'assets/images/chf.png'

const CHFIcon = () => {
  return <img src={CHFImage} alt='chf' width={20} />
}

export default CHFIcon
